import { JwtPayload, jwtDecode } from 'jwt-decode';
import { Session } from '@ory/client';
import { DateTime } from 'luxon';

export interface JwtWithClaims extends JwtPayload {
  email: string;
  first: string;
  last: string;
  organization_id: string;
  permissions: string[];
  role: string;
  user_profile_id: string;
}

export function isJwtValid(jwt: string): boolean {
  const decoded = jwtDecode(jwt);
  if (!decoded.exp) {
    return false;
  }
  return decoded.exp * 1000 > Date.now();
}

export function isSessionValid(session: Session | undefined): boolean {
  if (!session) {
    return false;
  }

  const expiryDate = DateTime.fromISO(session.expires_at || '');
  if (!expiryDate.isValid) {
    return false;
  }
  if (expiryDate < DateTime.now()) {
    return false;
  }
  return session.active || false;
}

export function getUserNameFromSession(session: Session | undefined): string {
  if (!session) {
    return '';
  }
  return (
    session.identity?.traits?.name?.first +
    ' ' +
    session.identity?.traits?.name?.last
  );
}

// Renew a little early so a token cannot expire in flight or under clock skew.
const ACCESS_TOKEN_EXPIRY_MARGIN = { seconds: 30 };

export function isAccessTokenValid(accessToken?: string): boolean {
  if (!accessToken) {
    return false;
  }

  try {
    const { exp } = jwtDecode(accessToken);
    const expiry = DateTime.fromMillis((exp ?? 0) * 1000);
    return expiry.minus(ACCESS_TOKEN_EXPIRY_MARGIN) > DateTime.now();
  } catch (error) {
    return false;
  }
}
